(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('countdownEnded', function() {
    const headerEl = document.querySelector('.header');
    const announcementBarEl = document.querySelector('.announcement-bar');
    if (headerEl && announcementBarEl) {
      headerEl.style.top = 'var(--announcement-bar-height)';
      announcementBarEl.style.height = 'var(--announcement-bar-height)';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-reviews"] && !Shopify.designMode) return;
  try {
    
  const buttons = document.querySelectorAll('.industry-reviews__action-link');
  const allCarousels = document.querySelectorAll('.industry-reviews__inner > div');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.getAttribute('data-category');
      const carousel = document.querySelector(`#${category}`);
      allCarousels.forEach((carousel) => {
        carousel.classList.remove('active');
      });
      carousel.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  const desktopWindowMQ = window.matchMedia('(min-width: 768px)');
  const prefersReducedMotionMQ = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  );

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const initAllTimelines = (scope = document) => {
    const roots = (scope.querySelectorAll ? scope : document).querySelectorAll(
      '[data-timeline]',
    );
    for (const root of roots) {
      if (root.dataset.timelineInitialized === 'true') continue;
      initTimelineRoot(root);
    }
  };

  const initTimelineRoot = (root) => {
    const timelineItems = root.querySelectorAll(
      '.timeline__items-container .timeline__item',
    );
    if (!timelineItems || timelineItems.length === 0) {
      root.dataset.timelineInitialized = 'true';
      return;
    }

    const ac = new AbortController();
    const signal = ac.signal;
    let resizeObserver = null;
    root._timelineCleanup = () => {
      ac.abort();
      if (resizeObserver) resizeObserver.disconnect();
      delete root.dataset.timelineInitialized;
    };

    const timelineInner = root.querySelector('.timeline__desktop-container');
    const draggableIcon = root.querySelector(
      '.timeline__track.hide-on-mobile .timeline__drag-image-container',
    );
    const mobileDragIcon = root.querySelector(
      '.timeline__mobile-track-container .timeline__drag-image-container',
    );
    const timelineTrack = root.querySelector('.timeline__track.hide-on-mobile');
    const prevButton = root.querySelector('.timeline__nav-prev');
    const nextButton = root.querySelector('.timeline__nav-next');
    const mobileTrack = root.querySelector(
      '.timeline__mobile-track-container .timeline__track',
    );
    const paginationDots = root.querySelectorAll('.timeline__pagination-dot');

    let distribution =
      timelineItems.length > 0 ? 100 / timelineItems.length : 0;
    let tallestItemHeight = 0;
    let activeIndex = 0;
    let suppressScrollSync = false;

    const updateDots = (currentIndex) => {
      paginationDots.forEach((dot, i) => {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const updateArrowState = (currentIndex) => {
      if (prevButton) prevButton.disabled = currentIndex === 0;
      if (nextButton)
        nextButton.disabled = currentIndex === timelineItems.length - 1;
    };

    const applyItemHeights = () => {
      const isDesktop = desktopWindowMQ.matches;
      timelineItems.forEach((item) => {
        item.style.height = isDesktop && tallestItemHeight
          ? `${tallestItemHeight}px`
          : '';
      });
    };

    const setActiveItem = (index, options = {}) => {
      const { instant = false } = options;
      const clampedIndex = clamp(index, 0, timelineItems.length - 1);
      activeIndex = clampedIndex;

      timelineItems.forEach((item, i) => {
        item.classList.toggle('active', i === clampedIndex);
      });
      applyItemHeights();

      const iconLeftPercent = `${distribution * clampedIndex}%`;
      if (draggableIcon) {
        draggableIcon.style.setProperty('--icon-left', iconLeftPercent);
      }

      if (
        !desktopWindowMQ.matches &&
        timelineInner &&
        timelineItems[clampedIndex]
      ) {
        const item = timelineItems[clampedIndex];
        const innerRect = timelineInner.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const nextScroll =
          timelineInner.scrollLeft +
          (itemRect.left - innerRect.left) -
          (innerRect.width - itemRect.width) / 3;
        const maxScroll = Math.max(
          0,
          timelineInner.scrollWidth - timelineInner.clientWidth,
        );
        const target = clamp(nextScroll, 0, maxScroll);
        const scrollBehavior =
          instant || prefersReducedMotionMQ.matches ? 'auto' : 'smooth';
        suppressScrollSync = true;
        timelineInner.scrollTo({ left: target, behavior: scrollBehavior });
        window.setTimeout(() => {
          suppressScrollSync = false;
        }, scrollBehavior === 'smooth' ? 400 : 0);
      }
      updateArrowState(clampedIndex);
      updateDots(clampedIndex);
    };

    const handleDesktopDraggable = () => {
      if (!draggableIcon || !timelineTrack) return;

      let isDragging = false;
      let startX = 0;
      let mousedownX = 0;
      const clampStart = 0;

      const getClampEnd = () =>
        timelineTrack.offsetWidth - draggableIcon.offsetWidth;

      const handleDrag = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const clampEnd = getClampEnd();
        const walk = startX + e.clientX - mousedownX;
        const clampedWalk = clamp(walk, clampStart, clampEnd);
        draggableIcon.style.setProperty('--icon-left', `${clampedWalk}px`);

        const percentDragged =
          clampEnd > 0 ? (clampedWalk / clampEnd) * 100 : 0;
        const nearestDistribution =
          Math.round(percentDragged / distribution) * distribution;
        const nearestIndex = clamp(
          Math.round(nearestDistribution / distribution),
          0,
          timelineItems.length - 1,
        );

        timelineItems.forEach((item, index) => {
          item.classList.toggle('active', index === nearestIndex);
        });
        activeIndex = nearestIndex;
        updateArrowState(nearestIndex);
        updateDots(nearestIndex);
      };

      draggableIcon.addEventListener(
        'mousedown',
        (e) => {
          isDragging = true;
          startX = draggableIcon.offsetLeft;
          mousedownX = e.clientX;
        },
        { signal },
      );

      document.addEventListener(
        'mouseup',
        () => {
          isDragging = false;
        },
        { signal },
      );

      document.addEventListener('mousemove', handleDrag, { signal });
    };

    const handleArrowNavigation = () => {
      if (!prevButton && !nextButton) return;

      if (prevButton) {
        prevButton.addEventListener(
          'click',
          () => {
            if (activeIndex > 0) setActiveItem(activeIndex - 1);
          },
          { signal },
        );
      }

      if (nextButton) {
        nextButton.addEventListener(
          'click',
          () => {
            if (activeIndex < timelineItems.length - 1)
              setActiveItem(activeIndex + 1);
          },
          { signal },
        );
      }

      updateArrowState(activeIndex);
    };

    const handlePaginationDots = () => {
      paginationDots.forEach((dot) => {
        dot.addEventListener(
          'click',
          () => {
            const idx = Number.parseInt(
              dot.getAttribute('data-timeline-index'),
              10,
            );
            if (!Number.isNaN(idx)) setActiveItem(idx);
          },
          { signal },
        );
      });
    };

    const setMobileTrackWidth = () => {
      if (!mobileTrack || !timelineInner) return;
      const firstItem = timelineItems[0];
      const lastItem = timelineItems[timelineItems.length - 1];
      let width = timelineInner.scrollWidth;
      if (firstItem && lastItem) {
        const firstRect = firstItem.getBoundingClientRect();
        const lastRect = lastItem.getBoundingClientRect();
        const span = lastRect.right - firstRect.left;
        if (span > 0) width = span;
      }
      mobileTrack.style.setProperty('--mobile-width', `${width}px`);
    };

    const findClosestIndex = () => {
      if (!timelineInner || timelineItems.length === 0) return activeIndex;
      const innerRect = timelineInner.getBoundingClientRect();
      const innerCenter = innerRect.left + innerRect.width / 2;
      let closest = 0;
      let minDistance = Number.POSITIVE_INFINITY;
      timelineItems.forEach((item, i) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distance = Math.abs(itemCenter - innerCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closest = i;
        }
      });
      return closest;
    };

    const handleMobile = () => {
      const onScroll = () => {
        if (!timelineInner) return;
        if (mobileDragIcon) {
          mobileDragIcon.style.setProperty(
            '--icon-left',
            `${timelineInner.scrollLeft}px`,
          );
        }
        if (suppressScrollSync || desktopWindowMQ.matches) return;
        const closest = findClosestIndex();
        if (closest !== activeIndex) {
          activeIndex = closest;
          timelineItems.forEach((item, i) => {
            item.classList.toggle('active', i === closest);
          });
          updateArrowState(closest);
          updateDots(closest);
        }
      };

      if (timelineInner) {
        timelineInner.addEventListener('scroll', onScroll, {
          passive: true,
          signal,
        });
      }
    };

    const getExactHeight = (item) => {
      if (!item) return 0;
      const containers = item.querySelectorAll(
        '.timeline__item__title-container, .timeline__item__content-container',
      );
      return Array.from(containers).reduce((height, container) => {
        if (!container) return height;
        const styles = window.getComputedStyle(container);
        const marginTop = Number.parseFloat(styles.marginTop);
        const marginBottom = Number.parseFloat(styles.marginBottom);
        return height + container.offsetHeight + marginTop + marginBottom;
      }, 0);
    };

    const measureTallestHeight = () => {
      if (!timelineItems || timelineItems.length === 0) return 0;
      const previouslyActive = Array.from(timelineItems).map((item) =>
        item.classList.contains('active'),
      );
      timelineItems.forEach((item) => {
        item.classList.remove('active');
        item.style.height = '';
      });

      let tallest = 0;
      timelineItems.forEach((item) => {
        item.classList.add('active');
        const h = getExactHeight(item);
        if (h > tallest) tallest = h;
        item.classList.remove('active');
      });

      timelineItems.forEach((item, i) => {
        item.classList.toggle('active', previouslyActive[i]);
      });
      return tallest;
    };

    const syncMobileIconToScroll = () => {
      if (!timelineInner || !mobileDragIcon) return;
      mobileDragIcon.style.setProperty(
        '--icon-left',
        `${timelineInner.scrollLeft}px`,
      );
    };

    const recalcLayout = ({ instant = true } = {}) => {
      if (desktopWindowMQ.matches) {
        tallestItemHeight = measureTallestHeight();
      } else {
        tallestItemHeight = 0;
      }
      applyItemHeights();
      if (!desktopWindowMQ.matches) {
        setMobileTrackWidth();
      }
      setActiveItem(activeIndex, { instant });
      if (!desktopWindowMQ.matches) {
        syncMobileIconToScroll();
      }
    };

    let resizeRaf = 0;
    const scheduleRecalc = () => {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(() => {
        resizeRaf = 0;
        recalcLayout({ instant: true });
      });
    };

    distribution = timelineItems.length > 0 ? 100 / timelineItems.length : 0;

    handleDesktopDraggable();
    handleArrowNavigation();
    handlePaginationDots();
    handleMobile();

    for (const [index, item] of timelineItems.entries()) {
      item.addEventListener(
        'click',
        () => {
          setActiveItem(index);
        },
        { signal },
      );
    }

    recalcLayout({ instant: true });

    window.addEventListener('resize', scheduleRecalc, { signal });
    desktopWindowMQ.addEventListener('change', scheduleRecalc, { signal });

    if (typeof window.ResizeObserver === 'function' && timelineInner) {
      resizeObserver = new window.ResizeObserver(() => scheduleRecalc());
      resizeObserver.observe(timelineInner);
    }

    root.dataset.timelineInitialized = 'true';
  };

  document.addEventListener('DOMContentLoaded', () =>
    initAllTimelines(document),
  );
  document.addEventListener('shopify:section:load', (event) =>
    initAllTimelines(event.target),
  );
  document.addEventListener('shopify:section:unload', (event) => {
    for (const root of event.target.querySelectorAll('[data-timeline]')) {
      if (typeof root._timelineCleanup === 'function') root._timelineCleanup();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
